<template>
  <page-wrapper
    ref="pageEl"
    :title="title"
    :is-job-list-page="true"
    :show-filter-result="searchResultCount"
    @showMobileNavBar="showMobileNavBar"
    @showMobileFilter="showMobileFilter"
  >
    <!-- Mobile filter dialog -->
    <div v-if="isShowMobileFilterDialog" class="dialog-bg">
      <div class="dialog-box">
        <div class="header">
          <p>{{ "ตัวกรอง" }}</p>
          <div class="close-btn" @click="hideMobileFilter">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="content">
          <search-form
            :project-results="projectResults"
            @searchSubmit="handleSearchSubmit"
          ></search-form>
        </div>
      </div>
    </div>
    <!-- Desktop filter -->
    <search-form
      v-if="isDesktop"
      :project-results="projectResults"
      @searchSubmit="handleSearchSubmit"
    ></search-form>
    <p v-if="total" class="total-count">{{ totalCount }}</p>
    <div v-if="noResult && !loader" class="p-4 text-center">ไม่มีข้อมูล</div>
    <div v-if="!noResult" class="job-list-wrapper">
      <!-- Job list header -->
      <div v-if="isDesktop" class="header">
        <div class="item">สถานะ</div>
        <div class="item">ครั้งที่</div>
        <div class="item">ชื่อบริการ</div>
        <div class="item">ลูกค้า</div>
        <div class="item">นัดหมาย</div>
        <div class="item">หมายเหตุลูกค้า</div>
      </div>
      <!-- Job list -->
      <div v-for="job in jobResults" :key="job.id">
        <job-list-item :job="job"></job-list-item>
      </div>
    </div>
    <!-- Job list pagination -->
    <div v-if="!noResult" class="text-center mt-4">
      <el-pagination
        :pager-count="5"
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import { Pagination } from "element-ui"
import { baanRueJaiClient } from "@/dependencies"
import PageWrapper from "../components/SupplierPageWrapper"
import SearchForm from "../components/SearchForm"
import JobListItem from "../components/JobListItem"
import { mSize } from "../StaticVariable"
import { stringToJson } from "../../lib/jsonFormatter"
import { navigationMenu } from "../../lib/mapper"

export default {
  components: {
    PageWrapper,
    SearchForm,
    JobListItem,
    "el-pagination": Pagination,
  },
  data() {
    const providerId = localStorage.getItem("supplierProviderId")
    const filter = {
      providerId: null,
      page: null,
      dateTime: null,
      project: null,
      home: null,
      status: null,
      user: null,
    }

    return {
      windowWidth: window.innerWidth,
      showMobileFilterDialog: false,
      providerId,
      filter,
      total: 0,
      searchResultCount: 0,
      jobResults: [],
      projectResults: [],
    }
  },
  computed: {
    loader() {
      return this.$store.state.loader
    },
    isDesktop() {
      return this.windowWidth >= mSize
    },
    navigationMenu() {
      return this.$route.params.navigationMenu
    },
    title() {
      switch (this.navigationMenu) {
        case navigationMenu.NEW:
          return "รอยืนยัน"
        case navigationMenu.PENDING:
          return "รอดำเนินการ"
        case navigationMenu.FINISHED:
          return "ปิดงานแล้ว"
        default:
          return ""
      }
    },
    jobStatus() {
      switch (this.navigationMenu) {
        case navigationMenu.NEW:
          return "CREATED"
        case navigationMenu.PENDING:
          return "CONFIRMED"
        case navigationMenu.FINISHED:
          return "PROVIDER_FULFILLED"
        default:
          return ""
      }
    },
    isShowMobileFilterDialog() {
      return this.showMobileFilterDialog
    },
    totalCount() {
      const total = this.total ? this.total.toLocaleString() : 0

      return `ทั้งหมด ${total} รายการ`
    },
    noResult() {
      return this.jobResults.length === 0
    },
    queryParams() {
      const query = {}

      const { providerId, page, dateTime, project, home, status, user } =
        this.filter

      if (providerId) {
        query.providerId = providerId
      }

      if (page) {
        query.page = page
      }

      if (dateTime) {
        query.dateTime = stringToJson(dateTime)
      }

      if (project) {
        query.projectId = stringToJson(project).id
      }

      if (home) {
        query.homeId = stringToJson(home).id
      }

      if (status) {
        query.status = status
      }

      if (user) {
        query.userId = stringToJson(user).id
      }

      return query
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      this.setupQuery()
      await this.setupData()

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
  },
  created() {
    this.setup()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth

      if (this.isDesktop) {
        this.hideMobileFilter()
      }
    },
    setup() {
      this.setupQuery()
      this.setupData()
    },
    setupQuery() {
      this.filter = {
        providerId: this.providerId,
        page: parseInt(this.$route.query.page, 10) || 1,
        dateTime: this.$route.query.dateTime,
        project: this.$route.query.project,
        home: this.$route.query.home,
        status: this.jobStatus,
        user: this.$route.query.user,
      }
    },
    async setupData() {
      this.setupSearchResult()
      await this.setupAppointmentList()
      await this.setupProjects()
    },
    setupSearchResult() {
      this.searchResultCount = this.getSearchResultCount()
    },
    async setupAppointmentList() {
      try {
        const params = this.queryParams

        const appointment = await this.fetchAppointmentList(params)

        this.total = appointment.count
        this.jobResults = appointment.appointments
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async fetchAppointmentList(params) {
      return baanRueJaiClient.others.supplier.getProviderAppointmentList(params)
    },
    async setupProjects() {
      const params = { status: this.jobStatus }

      const projects = await this.fetchProjects(params)

      this.projectResults = projects
    },
    async fetchProjects(params) {
      return baanRueJaiClient.others.supplier.getProjectsByAppointmentStatus(
        params,
      )
    },
    showMobileNavBar() {
      this.$emit("showMobileNavBar")
    },
    showMobileFilter() {
      this.showMobileFilterDialog = true
    },
    hideMobileFilter() {
      this.showMobileFilterDialog = false
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
    handleSearchSubmit(filter) {
      this.hideMobileFilter()

      const query = {}

      const { dateTime, project, home, status, user } = filter

      if (dateTime) {
        query.dateTime = dateTime
      }

      if (project) {
        query.project = project
      }

      if (home) {
        query.home = home
      }

      if (status) {
        query.status = status
      }

      if (user) {
        query.user = user
      }

      const route = {
        name: this.$route.name,
        query: { ...query },
      }

      this.$router.replace(route)
    },
    getSearchResultCount() {
      const results = {}

      const { project, home, user, dateTime } = this.filter

      if (project) {
        results.project = true
      }

      if (home) {
        results.home = true
      }

      if (user) {
        results.user = true
      }

      if (dateTime) {
        const dateTomeJSON = stringToJson(dateTime)
        results.dateFrom = true

        if (dateTomeJSON.hasDateTo) {
          results.dateTo = true
        }
      }

      return Object.values(results).length
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.dialog-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;

  > .dialog-box {
    background-color: $white;
    border-radius: 8px;
    width: 320px;
    max-height: 100%;
    overflow-y: auto;

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $supplier-primary-color;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;

      p {
        padding-inline: 16px;
        padding-block: 8px;
        font-size: $font-18;
        font-weight: bold;
        color: $white;
      }

      > .close-btn {
        padding-inline: 16px;
        padding-block: 8px;
        color: $white;
        cursor: pointer;

        &:hover:not(:disabled) {
          opacity: 0.7;
        }
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
    }
  }
}

.total-count {
  padding-inline: 24px;
  padding-bottom: 16px;
  font-size: $font-14;
}

.job-list-wrapper {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  overflow-x: auto;

  > .header {
    position: sticky;
    top: 0;
    display: grid;
    width: max-content;
    grid-template-columns: 130px 100px 250px 170px 280px 220px;
    grid-gap: 16px;
    border-block: 1px solid $color-light-gray-1;
    padding: 12px 24px;
    background-color: $color-background;

    > .item {
      font-size: 16px;
      color: $color-gray;
    }
  }
}

@media (max-width: ($m-size - 1)) {
  .total-count {
    padding-top: 16px;
    padding-bottom: 0;
  }

  .job-list-wrapper {
    padding-top: 16px;
    grid-gap: 16px;
  }
}
</style>
